import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 9,
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 5.57129V11",
			stroke: "white",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 12.4282H12",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4287 8.99986L9.00014 5.57129L5.57157 8.99986",
			stroke: "white",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUploadIcon;
